import {DetailTable} from '../../../mapping-classes/detail-table';
import {PaginationModel} from '../../models/Onlinekeys-search.model';

export class Onlinekeysearch implements DetailTable {
  shieldedText = '';
  restrictedData: boolean;
  title: string;
  rowHeaders: string[];
  rowData: any[];
  errorText: string;

  constructor(cards: any) {
    if (!cards || cards.length === 0) {
      this.createErrorMessage();
    } else {
      this.restrictedData = cards.restrictedData;
      this.rowHeaders = [];
      this.rowData = [];
      this.setRowHeaders();
      this.setRowData(cards);
    }
  }

  createErrorMessage() {
    this.errorText = 'Er zijn geen deelnemende rekeningen.';
  }

  setRowHeaders() {
    this.rowHeaders = [
      'icon',
      'arrangementNumber',
      'status',
      'cardType',
      'cardArrangementNumber',
      'cardArrangementStatus',
      'settlementAccountNumber',
      'cardNumber',
      'sequenceNumber',
      'replacedSequenceNumber',
      'cardHolder',
      'cardStatus',
      'cancellationDate',
      'relatedRelation',
    ];
  }

  setRowData(cards) {
    cards.forEach((card) => {
      if (this.restrictedData) {
        card.compensationLimit = this.shieldedText;
        card.actualBalance = this.shieldedText;
      }
      this.rowData.push(card);
    });
  }
}
